import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {



  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/document/common";


  url1 = environment.serverAPI9 + "/api/crmNotes";



  getAllDocument(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }


  saveDocument(lead: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, lead)
  }

  getDocumentById(docuemntId: number): Observable<Object> {
    return this.http.get(`${this.url}/${docuemntId}`);
  }

    documentSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

 deleteByNoteId(id: any): Observable<Object> {
    return this.http.delete(`${this.url1}/${id}`);
  }

    getAllDocumentDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }




}
